<!-- 学生多学籍切换组件 -->
<template>
  <a-modal
    title="多学籍切换"
    width="520px"
    :visible="visible"
    :destroyOnClose="true"
    :maskClosable="true"
    okText="确定"
    @cancel="handleCancel"
    @ok="confirmSwitch"
    class="enrollment-modal"
  >
    <div class="enrollment-radio-group">
      <a-radio-group v-model="selectedId" class="radio-group" v-if="enrollmentList.length">
        <div v-for="item in enrollmentList" :key="item.uid" class="radio-item" :class="{ 'radio-item-checked': selectedId === item.uid }">
          <a-radio :value="item.uid">
            <span style="margin-left: 0px;">{{ item.grade }}</span>
            <span style="margin-left: 12px;">层次：{{ item.learnLevel }}</span>
            <span style="margin-left: 12px;">专业：{{ item.professionName }}</span>
            <span style="margin-left: 12px;">学校：{{ item.collegeName }}</span>
          </a-radio>
        </div>
      </a-radio-group>
    </div>

    <a-divider style="margin: 10px 0" />

    <div class="enrollment-switch-tip">
      <a-icon type="exclamation-circle" theme="filled" style="font-size: 17px; margin-right: 8px;" />
      学籍切换后，页面内容将根据您的选择重新匹配内容
    </div>

    <template #footer>
      <a-button type="primary" @click="confirmSwitch" :loading="switching">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import { error } from 'jquery';

export default {
  name: 'EnrollmentSwitch',
  props: {
    // 控制弹窗显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 当前学籍ID，用于标记“当前学籍”
    curStuId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      enrollmentList: [], // 学籍列表
      selectedId: null, // 用户选中的学籍ID
      switching: false, // 切换中loading
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.loadEnrollmentList();
        }
      },
      immediate: true,
    },
    curStuId: {
      handler(val) {
        if (val) {
          this.selectedId = val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 查询学生学籍列表
     */
    loadEnrollmentList() {
      this.axios
        .get('/biz/archive/getEnrollmentList')
        .then(res => {
          if (res.success && res.result && res.result.length > 1) {
            this.enrollmentList = res.result;
            this.selectedId = this.curStuId;
          } else {
            this.enrollmentList = [];
          }
        })
        .catch(() => {
          this.enrollmentList = [];
        });
    },

    /**
     * 切换学籍
     */
    async confirmSwitch() {
      const that = this;
      if (!that.selectedId) {
        that.$message.warning('请选择要切换的学籍');
        return;
      }
      if (that.selectedId === that.curStuId) {
        // 切换账号和登录账号相同，不处理
        that.$emit('update:visible', false);
        return;
      }
      that.switching = true;

      try {
        // 登录新账号（切换到新学籍）
        const switchRes = await that.axios.get(`/sys/switch/quickLogin?uid=${that.selectedId}`);
        if (!switchRes.success) {
          that.$message.error(switchRes.message || '学籍切换失败，请稍后重试');
          that.switching = false;
          return;
        } else {
          // 退出历史登录账号
          const logoutRes = await that.axios.get(`/sys/logout`);
          if (!logoutRes.success) {
            that.$message.error(logoutRes.message || '学籍切换失败，请稍后重试');
            that.switching = false;
            return;
          }

          // 登录成功后操作
          const userInfo = switchRes.result.userInfo;
          const token = switchRes.result.token;
          if (userInfo && token) {
            userInfo.eduHomeUrl = switchRes.result.eduHomeUrl || null;
            userInfo.eduLogo = switchRes.result.eduLogo || null;
            that.common.switchLoginSuccess(token, userInfo);
          }
        }
      } finally {
        that.switching = false;
        that.$emit('update:visible', false);
      }
    },

    /**
     * 取消弹框
     */
    handleCancel() {
      this.enrollmentList = [];
      this.selectedId = '';
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
.radio-group {
  width: 100%;
}
.radio-item {
  padding: 8px 16px;
  border-radius: 24px;
  transition: all 0.2s;
}

.radio-item-checked {
  background-color: #ecf5ff;
}

.ant-radio-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.enrollment-switch-tip {
  color: red;
  font-size: 14px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
}

.enrollment-modal >>> .ant-modal-body {
  padding: 14px 12px 4px;
  border-top: none;
}

.enrollment-modal >>> .ant-modal-footer {
  padding: 2px 16px 8px;
  border-top: none;

  .ant-btn {
    font-size: 14px;
    padding: 2px 24px;
    border-radius: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/EnrollmentSwitch.vue